import React, { Fragment, memo, useContext } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Backdrop as MuiBackdrop,
  Grow,
  withStyles,
} from '@material-ui/core';

import { Icon, Button, Toggle, MaterialHint, Label } from 'shared/components';
import { useTrappedFocus } from 'shared/hocs/useTrappedFocus';
import { AccessibilityContext } from 'App';
import theme from './AccessibilityPopover.scss';
import AccessibilityStatementButton from '../AccessibilityStatementButton';


const Backdrop = withStyles({
  root: {
    zIndex: 1,
  },
})(MuiBackdrop);

const AccessibilityPopover = ({
  popoverOpened,
  closePopover,
  intl,
}) => {
  const focusContainerRef = useTrappedFocus();
  const accessibility = useContext(AccessibilityContext);

  return (
    <Fragment>

      <Grow in={ popoverOpened } unmountOnExit>
        <div className={ theme.root } ref={ focusContainerRef }>
          <div className={ theme.title }>
            <FormattedMessage id="AccessibilityPopover.Title" defaultMessage="** Accessibility options" />
          </div>

          <div className={ theme.accessibilityContainerWrap }>
            <Label htmlFor="accessibility-toggle" isMobile={ false }>
              <div className={ theme.accessibilityContainer }>
                <Icon className={ theme.accessibilityIcon } name="wheel-chair" />
                <div className={ theme.accessibilityCaption }>
                  <FormattedMessage
                    id="Accessibility Popover.IncreaseColorContrastToggle.Label"
                    defaultMessage="** Increase color contrast"
                  />
                </div>
              </div>
              <Toggle
                checked={ accessibility.isAccessibilityEnabled }
                onChange={ accessibility.toggleAccessibilityMode }
                id="accessibility-toggle"
              />
            </Label>
          </div>

          <AccessibilityStatementButton closePopover={ closePopover } />

          <footer className={ theme.footer }>
            <MaterialHint
              placement="right"
              title={ intl.formatMessage({ id: 'AccessibilityPopover.CloseButton.Tooltip', defaultMessage: '** Close accessibility options' }) }
            >
              <div>
                <Button
                  size="small"
                  testId="accessibility-popover-cancel-button"
                  buttonType="naked"
                  label={ intl.formatMessage({ id: 'General.Close', defaultMessage: '** Close' }) }
                  labelColor="blackMedium"
                  onClick={ closePopover }
                />
              </div>
            </MaterialHint>
          </footer>
        </div>
      </Grow>
      { popoverOpened && (
        <Backdrop
          open={ popoverOpened }
          onClick={ closePopover }
          invisible
        />
      ) }
    </Fragment>
  );
};

export default memo(injectIntl(AccessibilityPopover));
